import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'ups-timepicker',
    templateUrl: './timepicker.type.component.html',
    styleUrls: ['./timepicker.type.component.scss'],
    standalone: false
})
export class TimepickerTypeComponent extends FieldType implements OnInit {
  public times: string[] = [];

  public isOpen: boolean = false;
  @ViewChild('sdlsCombobox') sdlsCombobox!: ElementRef;

  public open(): void {
    this.isOpen = !this.isOpen;
  }

  ngOnInit() {
    this.generateTime();
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.sdlsCombobox.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  public setValue(value: string): void {
    this.formControl.setValue(value);
    this.isOpen = false;
  }

  private generateTime(): void {
    const meridians: string[] = ['AM', 'PM'];

    meridians.forEach((meridian) => {
      this.times.push(`12:00 ${meridian}`);
      this.times.push(`12:30 ${meridian}`);
      for (let hour = 1; hour <= 11; hour++) {
        this.times.push(`${hour}:00 ${meridian}`);
        this.times.push(`${hour}:30 ${meridian}`);
      }
    });
  }
}
